import { format, getDay } from 'date-fns';
import { useMemo } from 'react';
import {
  EvaluationCalendarSummary,
  useEvaluationCalendarSummary,
  UseSummaryCalendarParams,
} from '../v3/useEvaluationCalendarSummary';
import { sortBy } from 'lodash';
import { UseQueryResult } from 'react-query';

type Params = UseSummaryCalendarParams & {
  firstSession: Date;
};

export const useSecondRecurringSessionCalendar = ({
  firstSession,
  ...params
}: Params): UseQueryResult<EvaluationCalendarSummary> => {
  const query = useEvaluationCalendarSummary(params);
  const { data: summaryData } = query;

  const results = useMemo(() => {
    if (!summaryData) return undefined;
    return processSummaryData(summaryData, firstSession);
  }, [summaryData, firstSession]);

  if (!query.data) {
    return query;
  }

  return {
    ...query,
    data: results as EvaluationCalendarSummary,
  };
};

const processSummaryData = (data: EvaluationCalendarSummary, firstSession: Date): EvaluationCalendarSummary => {
  let result = data.summaryData;

  result = result.filter(dayData => format(dayData.day, 'EEEE') !== format(firstSession, 'EEEE'));

  result = sortBy(result, dayData => {
    const dayIndex = getDay(dayData.day);
    // Shift the index so Monday (1) becomes 0, Sunday (0) becomes 6
    return (dayIndex + 6) % 7;
  });

  return {
    summaryData: result,
    totalTimeSlots: Object.values(result).reduce((acc, day) => acc + day.timeSlotCount, 0),
  };
};
